const TODAY_MONTH = new Date().toLocaleString("en", { month: "long" });

const CARDS = [
  { key: "total",       label: "Total Leads",     color: "var(--ps-ink)",     sub: "open + closed" },
  { key: "qualified",   label: "Qualified",       color: "var(--stage-qual-fg)", sub: "discovery done" },
  { key: "demo",        label: "Demo Scheduled",  color: "var(--stage-demo-fg)", sub: "product walk-through" },
  { key: "negotiation", label: "In Negotiation",  color: "var(--stage-neg-fg)",  sub: "price · MSA · POC" },
  { key: "won_this_month", label: `Won · ${TODAY_MONTH}`, color: "var(--stage-won-fg)", sub: "this month" },
];

export default function PresalesStatStrip({ stats }) {
  if (!stats) {
    return (
      <div className="ps-stats">
        {CARDS.map((c) => (
          <div key={c.key} className="ps-stat" style={{ "--stat-c": c.color }}>
            <div className="ps-stat-head">
              <span className="ps-stat-swatch" />
              {c.label}
            </div>
            <div className="ps-stat-count">—</div>
            <div className="ps-stat-sub">{c.sub}</div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="ps-stats">
      {CARDS.map((c) => (
        <div key={c.key} className="ps-stat" style={{ "--stat-c": c.color }}>
          <div className="ps-stat-head">
            <span className="ps-stat-swatch" />
            {c.label}
          </div>
          <div className="ps-stat-count">{stats[c.key] ?? "—"}</div>
          <div className="ps-stat-sub">{c.sub}</div>
        </div>
      ))}
    </div>
  );
}
